import {
    MLInputType,
    MLProcessor,
} from '@models';

export interface IMLPackageVersion {
    id: string;
    createdBy: string;
    status: MLPackageStatus;
    createdOn: Date;
    modifiedOn: Date;
    version: number;
    changeLog: string;
    modelLanguage: MLLanguage;
    outputDescription: string;
    inputType: MLInputType;
    inputDescription: string;
    contentUri: string;
    processorType: MLProcessor;
}

export enum MLPackageStatus {
    Available = 'AVAILABLE',
    Unavailable = 'UNAVAILABLE',
    Deploying = 'DEPLOYING',
    Deployed = 'DEPLOYED',
    Purged = 'PURGED',
    Undeployed = 'UNDEPLOYED',
    Validating = 'VALIDATING',
}

export enum MLLanguage {
    PYTHON36 = 'Python 3.6',
    PYTHON27 = 'Python 2.7',
    R = 'R',
    // tslint:disable-next-line: naming-convention
    MOJO_PIPELINE = 'Mojo Pipeline',
}
